import {
    Box,
    Image,
    Show,
    Hide,
    Flex,
    Grid,
    GridItem,
    Heading,
    Text,
    css,
    Link,
} from '@chakra-ui/react';

import StyledButton from '../../components/Button/Button';
import { MainHeroHeading, StyledContainer } from './styles';
import { buttonVariant } from '../../types/buttonTypes';

export interface HeroProps {
    title: string | JSX.Element;
    subTitle?: string | JSX.Element;
    type?: 'landing' | 'integration';
    badgeLabel?: string;
    gap?: string;
    paddingDesktop?: string;
    ratio?: '3/4';
    stickyImage?: boolean;
    badgeImage?: {
        url: string;
        alt: string;
    };
    image: {
        url: string;
        alt: string;
    };
    buttons?: {
        title: string;
        href: string;
        variant: buttonVariant;
        target?: string;
    }[];
    integrationInfo?: {
        integrationCategory: string;
        integrationName: string;
        integrationHref?: string;
    };
}

const HeroSection: React.FC<HeroProps> = ({
    type = 'landing',
    integrationInfo,
    title,
    gap,
    ratio,
    subTitle,
    paddingDesktop,
    stickyImage,
    badgeLabel,
    badgeImage,
    image,
    buttons,
}) => {
    const paddingOfLeftSide =
        type === 'integration'
            ? { md: '40px 50px', xl: '106px 50px' }
            : { base: '20px 0', xl: paddingDesktop ? paddingDesktop : '20px 0' };
    return (
        <Box
            className="hero_section"
            position="relative"
            css={
                type === 'landing' &&
                css({
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        height: '100%',
                        top: 0,
                        width: '100vw',
                        marginLeft: '50%',
                        left: '-50vw',
                        zIndex: -2,
                        backgroundColor: '#1AAC7A', // Replace with your theme color reference
                    },
                })
            }
        >
            {integrationInfo && (
                <Flex
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    padding={'30px 0'}
                    maxW={'1200px'}
                    margin={'0 auto'}
                    width={'95%'}
                    flexWrap={'wrap'}
                    id="hero_section_integration_info"
                >
                    <Flex flexDir={'column'} marginBottom={{ base: '20px', md: 'none' }}>
                        <Text fontSize={'12px'} lineHeight={'19px'}>
                            {integrationInfo?.integrationCategory}
                        </Text>
                        <Text fontSize={'34px'} lineHeight={'48px'} fontWeight={'600'}>
                            {integrationInfo?.integrationName}
                        </Text>
                    </Flex>
                    <Flex gap={'30px'} alignItems={'center'} flexWrap={'wrap-reverse'}>
                        <Text>
                            Nie masz jeszcze sklepu?{' '}
                            <Link href="#" textDecor={'underline'}>
                                Wypróbuj IdoSell za darmo
                            </Link>
                        </Text>
                        <StyledButton
                            marginBottom={'10px !important'}
                            href={
                                integrationInfo.integrationHref
                                    ? integrationInfo.integrationHref
                                    : '#'
                            }
                            style={'outline'}
                            target="_blank"
                        >
                            {'Włącz integracje'}
                        </StyledButton>
                    </Flex>
                </Flex>
            )}
            <Show below="lg">
                <Flex height={'300px'} mb={4} margin={'0 calc(-1 *(100vw - 100%)/2)'}>
                    <img
                        //@ts-expect-error
                        fetchpriority="high"
                        src={image.url}
                        alt={image.alt}
                        width="100%"
                        style={{ objectFit: 'cover' }}
                    />
                </Flex>
            </Show>
            <Box overflow={'hidden'} className=" containerIdosellPages">
                <Grid
                    templateColumns={{ base: '1fr', lg: ratio === '3/4' ? '3fr 4fr' : '1fr 1fr' }}
                    gap={
                        type === (undefined || 'landing')
                            ? gap
                                ? gap + 'px'
                                : '50px'
                            : gap
                            ? gap + 'px'
                            : '0'
                    }
                    alignItems={type === (undefined || 'landing') ? 'center' : 'stretch'}
                    position="relative"
                >
                    <Hide above="lg">
                        <GridItem
                            order={{ base: 2, lg: 1 }}
                            padding={'20px 0'}
                            display={'flex'}
                            flexDirection={'column'}
                            alignItems={'flex-start'}
                            css={
                                type === 'integration' &&
                                css({
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        height: '100%',
                                        top: 0,
                                        width: '100vw',
                                        marginLeft: '50%',
                                        left: '-50vw',
                                        zIndex: -2,
                                        backgroundColor: '#1AAC7A', // Replace with your theme color reference
                                    },
                                })
                            }
                        >
                            {badgeLabel && (
                                <Text
                                    display={'flex'}
                                    color={'white'}
                                    p={2}
                                    mb={4}
                                    fontSize={'sm'}
                                    fontWeight={'bold'}
                                    border={'2px solid white'}
                                >
                                    {badgeLabel}
                                </Text>
                            )}
                            {badgeImage && (
                                <img
                                    //@ts-expect-error
                                    fetchpriority="high"
                                    src={badgeImage.url}
                                    alt={badgeImage.alt}
                                    width={'250px'}
                                    style={{ marginBottom: '15px' }}
                                />
                            )}
                            <MainHeroHeading style={{ textAlign: 'left', marginBottom: '15px' }}>
                                {title}
                            </MainHeroHeading>
                            {typeof subTitle === 'object' ? (
                                subTitle
                            ) : (
                                <Text
                                    textAlign={{
                                        base: 'center',
                                        lg: 'left',
                                    }}
                                    fontSize={{ md: 'md', lg: 'lg' }}
                                    color={'white'}
                                    mt={1}
                                >
                                    {subTitle}
                                </Text>
                            )}
                            <StyledContainer $flex="row">
                                {buttons?.map(button => {
                                    return (
                                        <StyledButton
                                            href={button.href}
                                            style={button.variant}
                                            target="_blank"
                                        >
                                            {button.title}
                                        </StyledButton>
                                    );
                                })}
                            </StyledContainer>
                        </GridItem>
                    </Hide>
                    <Hide below="lg">
                        <GridItem
                            order={{ base: 2, lg: 1 }}
                            padding={paddingOfLeftSide}
                            display={'flex'}
                            flexDirection={'column'}
                            alignItems={'flex-start'}
                            css={
                                type === 'integration' &&
                                css({
                                    background: '#1AAC7A',
                                })
                            }
                            id="hero_section_contents"
                        >
                            {badgeLabel && (
                                <Text
                                    display={'flex'}
                                    color={'white'}
                                    p={2}
                                    mb={4}
                                    fontSize={'11px'}
                                    fontWeight={'bold'}
                                    border={'2px solid white'}
                                >
                                    {badgeLabel}
                                </Text>
                            )}
                            {badgeImage && (
                                <img
                                    //@ts-expect-error
                                    fetchpriority="high"
                                    src={badgeImage.url}
                                    alt={badgeImage.alt}
                                    width={'250px'}
                                    style={{ marginBottom: '15px' }}
                                />
                            )}
                            <MainHeroHeading>{title}</MainHeroHeading>
                            {typeof subTitle === 'object' ? (
                                subTitle
                            ) : (
                                <Text
                                    textAlign={{
                                        base: 'center',
                                        lg: 'left',
                                    }}
                                    fontSize={'lg'}
                                    color={'white'}
                                    mt={1}
                                >
                                    {subTitle}
                                </Text>
                            )}
                            {buttons && (
                                <StyledContainer $flex="row">
                                    {buttons?.map(button => {
                                        return (
                                            <StyledButton
                                                href={button.href}
                                                style={button.variant}
                                                target={button.target ? button.target : '_blank'}
                                            >
                                                {button.title}
                                            </StyledButton>
                                        );
                                    })}
                                </StyledContainer>
                            )}
                        </GridItem>
                    </Hide>

                    <Hide below="lg">
                        <GridItem order={2}>
                            <Flex>
                                <img
                                    //@ts-expect-error
                                    fetchpriority="high"
                                    src={image.url}
                                    alt={image.alt}
                                    style={{ marginBottom: stickyImage ? '-215px' : '0' }}
                                />
                            </Flex>
                        </GridItem>
                    </Hide>
                </Grid>
            </Box>
        </Box>
    );
};

export default HeroSection;
